module.exports = __webpack_public_path__ + "static/img/logo2.f1bcd9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo2.png
// module id = OfyR
// module chunks = 426